const boxActionsMap = {
  edit_entity: 'edit_entity',
}
export default boxActionsMap
